import React, { Suspense, lazy, useEffect } from 'react';
import { Switch, Route, Redirect } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/layouts/adminStyle.js";
import bgImage from "../../assets/images/sidebar.jpeg";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import Description from '../../Pages/ETL-S3Configuration/Description';
import Sidebar from "../Sidebar/ETLSidebar";
import routes from "../../routes/etlRoutes";
import logo from "../../assets/images/logo.png";
import ScrollToTop from '../ScrollToTop/ScrollToTop';
import FileUpload from '../../Pages/ETL-S3Configuration/FileUpload';
import FileDownload from '../../Pages/ETL-S3Configuration/FileDownload';
import Header from '../../components/home/header/header';
import ReportsDashboard from '../../Pages/ETL-S3Configuration/ReportsDashboard';
import IngestionDashboard from '../../Pages/ETL-S3Configuration/IngestionDashboard';

const useStyles = makeStyles(styles);

const componentMap = {
  'IngestionDashboard': React.lazy(() => import('../../Pages/ETL-S3Configuration/IngestionDashboard')),
  'ReportsDashboard': React.lazy(() => import('../../Pages/ETL-S3Configuration/ReportsDashboard')),
  'FileUpload': React.lazy(() => import('../../Pages/ETL-S3Configuration/FileUpload')),
  'FileDownload': React.lazy(() => import('../../Pages/ETL-S3Configuration/FileDownload')),
  'Description': React.lazy(() => import('../../Pages/ETL-S3Configuration/Description')),
  // Add more as needed
};

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      if (prop.layout === "/etl") {
        return (
          <React.Fragment key={key}>
            {prop.subRoutes && prop.subRoutes.length > 0 ? (
              prop.subRoutes.map((subRoute, key1) => {
                const Component = componentMap[subRoute.component];
                if (!Component) return null;
                return (
                  <Route
                    key={key1}
                    path={subRoute.layout + subRoute.path}
                    render={(props) => (
                      <Component
                        {...props}
                        customValue={subRoute.parameter_store_name}
                        embedConsole={subRoute.embedConsole}
                        dashboardRole={subRoute.role}
                      />
                    )}
                  />
                );
              })
            ) : null}
          </React.Fragment>
        );
      }
      return null;
    })}
    <Redirect from="/etl" to="/etl/fileUpload" />
  </Switch>
);

let ps;
export default function EtlLayout() {
  useEffect(() => {
    console.log('EtlLayout mounted', Date.now());
    return () => {
      console.log('EtlLayout unmounted', Date.now());
    };
  }, []);
  // styles
  const classes = useStyles();
  const mainPanel = React.createRef();
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [mobileOpen, setMobileOpen] = React.useState(false);

  React.useEffect(() => {
    document.getElementsByTagName("body")[0].classList.add("normal-layout-container");
    document.getElementsByTagName("body")[0].classList.remove("awe-layout-container");
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    return () => {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  return (
    <div className="App main-layout-background">
      <Header />
      <div className="router-box">
        <div className={classes.wrapper}>
          <Sidebar
            routes={routes}
            logo={logo}
            image={image}
            handleDrawerToggle={handleDrawerToggle}
            open={mobileOpen}
            color={color}
          />
          <div className={classes.mainPanel} ref={mainPanel}>
            <ScrollToTop>
              <div className={classes.content}>
                <div className={classes.container}>
                  <Suspense fallback={<div>Loading...</div>}>
                    {switchRoutes}
                  </Suspense>
                </div>
              </div>
            </ScrollToTop>
          </div>
        </div>
      </div>
    </div>
  );
}
